import {
	Breakpoints,
	Container,
	ContainerPadding,
	CTA,
	Layout,
	Text,
	TextAlignment,
	TextTag,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { BehaviorSubject } from 'rxjs';

import { CompleteRegisterForm } from './complete-register-form';
import { PortalContext } from '../../../../context/PortalContext';
import { Form } from '@esportal/portal-service';
import { Environment } from '../../../../enviroment';
import { useTrackingManager } from '../../../../tracking/useTrackingManager';

export const DialogCompleteRegister: React.FC<{
	state$: BehaviorSubject<Form | null>;
	submit: (state: any) => void;
}> = ({ state$, submit }) => {
	const { navigationService } = React.useContext(PortalContext);
	const portalContext = React.useContext(PortalContext);

	const trackingManager = useTrackingManager();

	const [state, setState] = React.useState<any>();

	const environmentPath = Environment.getInstance().condicionesUsoClubVW;
	const target = navigationService.navigateTo(environmentPath, {});

	const handleOnClick = () => {
		if (target) {
			target.push();
		}
	};

	React.useEffect(() => {
		state$.subscribe(setState);
	}, [state$]);

	const handleSubmitOnClick = (state: Partial<Form>) => {
		submit(state);
		trackingManager.trackClubVWFormCTAClick(
			{
				FormName: 'Club VW Register form',
				FormStart: false,
				FormTypeMultiple: ['registration'],
			},
			{ contentId: 'Unirme al club' },
			{ vehicle: [] },
		);
	};

	return (
		<PortalContext.Provider value={portalContext}>
			<Container data-testid="dialog-complete-register-container" wrap={'always'} stretchContent>
				<CompleteRegisterForm
					handleChangeData={(form: any) => {
						state$.next(form);
					}}
				/>
				<Layout
					data-testid="login-layout"
					appearance={{
						[Breakpoints.default]: [
							{ name: '.', columns: 1 },
							{ name: 'a', columns: 22 },
							{ name: '.', columns: 1 },
							{ name: '.', columns: 1 },
							{ name: 'b', columns: 22 },
							{ name: '.', columns: 1 },
						],
						[Breakpoints.b560]: [
							{ name: '.', columns: 1 },
							{ name: 'a', columns: 22 },
							{ name: '.', columns: 1 },
							{ name: '.', columns: 6 },
							{ name: 'b', columns: 12 },
							{ name: '.', columns: 6 },
						],
						[Breakpoints.b960]: [
							{ name: '.', columns: 2 },
							{ name: 'a', columns: 20 },
							{ name: '.', columns: 2 },
							{ name: '.', columns: 8 },
							{ name: 'b', columns: 8 },
							{ name: '.', columns: 8 },
						],
						[Breakpoints.b1280]: [
							{ name: '.', columns: 4 },
							{ name: 'a', columns: 16 },
							{ name: '.', columns: 4 },
							{ name: '.', columns: 9 },
							{ name: 'b', columns: 6 },
							{ name: '.', columns: 9 },
						],
						[Breakpoints.b1600]: [
							{ name: '.', columns: 6 },
							{ name: 'a', columns: 12 },
							{ name: '.', columns: 6 },
							{ name: '.', columns: 9 },
							{ name: 'b', columns: 6 },
							{ name: '.', columns: 9 },
						],
						[Breakpoints.b1920]: [
							{ name: '.', columns: 7 },
							{ name: 'a', columns: 10 },
							{ name: '.', columns: 7 },
							{ name: '.', columns: 10 },
							{ name: 'b', columns: 4 },
							{ name: '.', columns: 10 },
						],
						[Breakpoints.b2560]: [
							{ name: '.', columns: 8 },
							{ name: 'a', columns: 8 },
							{ name: '.', columns: 8 },
							{ name: '.', columns: 10 },
							{ name: 'b', columns: 4 },
							{ name: '.', columns: 10 },
						],
					}}
					allowOverflowingContent
				>
					<Container
						padding={{
							top: ContainerPadding.dynamic0150,
							bottom: ContainerPadding.dynamic0150,
						}}
						wrap={'never'}
						horizontalAlign={'center'}
						verticalAlign={'center'}
						stretchContent
					>
						<Text
							tag={TextTag.p}
							appearance={TokenTextAppearance.copy200}
							textAlign={TextAlignment.center}
							color={TokenTextColor.primary}
						>
							Al registrarte aceptas las{' '}
							<CTA tag="a" emphasis="tertiary" onClick={handleOnClick} target="_blank">
								<Text appearance={TokenTextAppearance.copy200} color={TokenTextColor.primary}>
									Condiciones de uso de{' '}
								</Text>
							</CTA>
							<CTA tag="a" emphasis="tertiary" onClick={handleOnClick} target="_blank">
								<Text appearance={TokenTextAppearance.copy200} color={TokenTextColor.primary}>
									&nbsp;Club Volkswagen{' '}
								</Text>
							</CTA>
							. Puedes acceder a nuestra{' '}
							<CTA
								tag="a"
								emphasis="tertiary"
								href="https://www.volkswagen.es/es/volkswagen-espana/politica-privacidad.html"
								target="_blank"
								onClick={() => {
									trackingManager.trackClubVWLinkClick(
										'Política de privacidad',
										{
											contentId: 'Navigate to privacy policy',
										},
										{ vehicle: [] },
									);
								}}
							>
								<Text appearance={TokenTextAppearance.copy200} color={TokenTextColor.primary}>
									Política de Privacidad.
								</Text>
							</CTA>
						</Text>
					</Container>
					<Container
						wrap={'never'}
						horizontalAlign={{
							[Breakpoints.default]: 'center',
						}}
						stretchContent
					>
						<CTA
							key="ok"
							tag="button"
							emphasis="primary"
							aria-label="Unirme al club"
							onClick={() => {
								handleSubmitOnClick(state);
							}}
							size="large"
							disabled={state ? !state?.isValid : true}
							stretchContent
						>
							<Text>Unirme al club</Text>
						</CTA>
					</Container>
				</Layout>
			</Container>
		</PortalContext.Provider>
	);
};
